import { ContactUsState, EnquiryType, IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  name: "",
  email: "",
  mobileNumber: "",
  description: "",
  file: "",
  enquiryType: EnquiryType.ENQUIRY,
  subject: "",
  companyName: "",
  departmentName: "",
  homePageUrl: "",
  postCode: "",
  prefectures: "",
  address: ""
};

export const initialState: ContactUsState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
};
